// extracted by mini-css-extract-plugin
export default {"notifications_overlay":"Notifications_notifications_overlay__UWFtF"};